export default "__VITE_ASSET__b3e60542__"